export const getSingleSiteAnalyserInfoUrl = "/api/v3/mavin/single_site/report";
